import React from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import DataPanelTabContent from "./dataPanelTabContent";
import SearchBar from "./dataPanelSearchBar";
import ToggleButton from "./ToggleButton";
import FeatherIcon from 'feather-icons-react';
import DataPanelFilterSelectionModal from './dataPanelFilterSelectionModal.jsx';
import './dataPanelTab.css';
import { DATA_PANEL_DATA_FIELDS, DATA_PANEL_FILTERS, getFieldNameForCardType, getTabSpecificOptions, hasNormalizedData, TAB_SPECIFIC_FIELDS, TAB_SPECIFIC_MAPPINGS, getLambdaDataValue as getSharedLambdaDataValue, PREPLAN_FIELD_MAPPINGS, NUMERIC_FIELDS, TEXT_FIELDS, CODE_FIELDS, BOOLEAN_FIELDS, DATE_FIELDS, NON_SORTABLE_FIELDS } from "./dataPanelFilterOptions.data";
import i18n from "../../../../../../_translations/i18n";
import moment from 'moment';
import * as XLSX from "xlsx-js-style";
import { RefreshCcw } from "lucide-react";
import { confirmAlert } from 'react-confirm-alert';
import { setShouldDownloadAfterRefresh, setTabFilterSelections, setTabSortConfig, setNormalizeToggleOn } from '../../../../../../actions/simulateAllActions';


class DataPanelTab extends React.Component {

    constructor(props) {
        super(props)
        this._isMounted = false;
        this.settingsIconRef = React.createRef();
        this.state = {
            itemSort: [
                { value: 1, label: this.props.t("BY_SALES") },
                { value: 2, label: this.props.t("BY_FACE_QTY") },
                { value: 3, label: this.props.t("BY_SALES_CYCLE") },
            ],
            searchQuery: "", // State for search input
            showFilterModal: false,
            originalToSimulateProduct: props.toSimulateProduct || [],
            toSimulateProduct: props.toSimulateProduct || [],
            isInSearchMode: false,
            isInFilterMode: false
        }
    }
    componentDidMount() {
        if (this.props.setFilterModeChangeRef) {
            this.props.setFilterModeChangeRef(this.handleFilterModeChange);
        }

        // Initialize filter selections from Redux or set defaults for all tabs if empty
        const tabs = ['product', 'brand', 'supplier', 'category', 'sub-category'];
        tabs.forEach(tab => {
            if (!this.props.tabFilterSelections[tab] || this.props.tabFilterSelections[tab].length === 0) {
                this.props.setTabFilterSelections(tab, getTabSpecificOptions(tab).slice(0, 3));
            }
        });

    }

    handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSearchModeChange = (isInSearchMode) => {
    this.setState({ isInSearchMode });
  };

  handleFilterModeChange = (isInFilterMode) => {
    this.setState({ isInFilterMode });
  };

  handleColumnSort = (filterOption) => {
    const currentTab = this.props.dataPanelTab || 'product';
    const sortConfig = this.props.tabSortConfig[currentTab];

    if (NON_SORTABLE_FIELDS.includes(filterOption.short)) {
        return;
    }

    let newSortConfig;
    // Toggle through states: default -> desc -> asc -> default
    if (sortConfig.key === filterOption.short) {
        if (sortConfig.direction === 'desc') {
            // Second click: switch to ascending
            newSortConfig = {
                key: filterOption.short,
                direction: 'asc'
            };
        } else {
            // Third click: back to default (no sort)
            newSortConfig = {
                key: null,
                direction: 'desc'
            };
        }
    } else {
        // First click: sort descending
        newSortConfig = {
            key: filterOption.short,
            direction: 'desc'
        };
    }

    this.props.setTabSortConfig(currentTab, newSortConfig);
  };

    componentDidUpdate(prevProps) {
        if (prevProps.toSimulateProduct !== this.props.toSimulateProduct) {
            this.setState({
                originalToSimulateProduct: this.props.toSimulateProduct,
                toSimulateProduct: this.props.toSimulateProduct,
            }, () => {
                // reapply search filter if there's an active search query
                if (this.state.searchQuery && this.state.searchQuery.length > 0) {
                    this.filterSimulatedData(this.state.searchQuery, this.props.dataPanelTab);
                }
            });

            // If waiting to download after refresh, check if data is ready
            if (this.props.shouldDownloadAfterRefresh && !this.props.isLoadingLambdaDataPanel) {
                // Component has re-rendered with fresh data, trigger download
                this.generateDataPanelExcelExport();
                // Reset the flag
                this.props.setShouldDownloadAfterRefresh(false);
            }
        }
    }

    // Get current filter selections for the active tab
    getCurrentFilterSelections = () => {
        const currentTab = this.props.dataPanelTab || 'product';
        return this.props.tabFilterSelections[currentTab] || [];
    }

  handleToggle = (isOn) => {
    this.props.setNormalizeToggleOn(isOn);
  };

  handleOpenFilterModal = () => {
    this.setState({ showFilterModal: true });
  };

  handleCloseFilterModal = () => {
    this.setState({ showFilterModal: false });
  };

  handleFilterConfirm = (selected) => {
    const currentTab = this.props.dataPanelTab || 'product';
    this.props.setTabFilterSelections(currentTab, selected);
  };

filterSimulatedData = (query, activeTab) => {
    const { originalToSimulateProduct } = this.state;

    // Helper function to get processed data for each tab type
    const getProcessedDataForTab = (activeTab) => {
        let dataToProcess = originalToSimulateProduct;

        switch (activeTab) {
            case "product":
                return dataToProcess;

            case "brand":
                // Remove duplicates based on brand name and subcategory
                dataToProcess = Array.from(new Map(originalToSimulateProduct.map(prod => {
                    const key = `${prod?.brand?.brandName}-${prod?.subCat?.subCategoryName}`;
                    return [key, prod];
                })).values());

                // Add noproduct brands if available (only if not in filter mode)
                if (this.props.hierarchyData?.noproductBrands && !this.state.isInFilterMode) {
                    this.props.hierarchyData.noproductBrands.forEach(brand => {
                        // Extract subcategory info - for noproduct brands, subcategoryName is at root level
                        const subcategoryName = brand.subcategoryName || brand.lambdaData?.subcategoryName;
                        const subCategoryId = brand.subCategoryId || brand.lambdaData?.subCategoryId;

                        const existingBrandById = dataToProcess.find(prod =>
                            prod?.brand?.brandid === brand.brandId &&
                            prod?.subCat?.subCategoryName === subcategoryName
                        );
                        const alreadyAddedNoproduct = dataToProcess.find(prod =>
                            prod?.type === 'noproduct-brand' &&
                            prod?.brand?.brandid === brand.brandId &&
                            prod?.subCat?.subCategoryName === subcategoryName
                        );
                        if (!existingBrandById && !alreadyAddedNoproduct) {
                            const brandIdKey = `${brand.brandId}-${subcategoryName}`;
                            dataToProcess.push({
                                type: 'noproduct-brand',
                                brand: {
                                    brandName: brand.brandName,
                                    brandid: brand.brandId
                                },
                                subCat: {
                                    subCategoryName: subcategoryName,
                                    subCategoryid: subCategoryId
                                },
                                brandLambdaData: brand.lambdaData,
                                brandNormalizedLambdaData: brand.normalizedLambdaData,
                                brandDataPanelData: brand.dataPanelData,
                                brandNow: 0,
                                brandRec: parseFloat((parseFloat(brand.lambdaData?.allocatedShareBrand) || 0).toFixed(2)),
                                barcode: `noproduct-brand-${brandIdKey}`,
                                name: brand.brandName
                            });
                        }
                    });
                }
                return dataToProcess;

            case "supplier":
                // Remove duplicates based on supplier name and subcategory
                dataToProcess = Array.from(new Map(originalToSimulateProduct.map(prod => {
                    const key = `${prod?.supplier?.supplierName}-${prod?.subCat?.subCategoryName}`;
                    return [key, prod];
                })).values());

                // Add noproduct suppliers if available (only if not in filter mode)
                if (this.props.hierarchyData?.noproductSuppliers && !this.state.isInFilterMode) {
                    this.props.hierarchyData.noproductSuppliers.forEach(supplier => {
                        // Extract subcategory info - for noproduct suppliers, subcategoryName is at root level
                        const subcategoryName = supplier.subcategoryName || supplier.lambdaData?.subcategoryName;
                        const subCategoryId = supplier.subCategoryId || supplier.lambdaData?.subCategoryId;

                        const existingSupplierById = dataToProcess.find(prod =>
                            prod?.supplier?.supplierId === supplier.supplierId
                        );
                        const alreadyAddedNoproduct = dataToProcess.find(prod =>
                            prod?.type === 'noproduct-supplier' &&
                            prod?.supplier?.supplierId === supplier.supplierId
                        );
                        if (!existingSupplierById && !alreadyAddedNoproduct) {
                            dataToProcess.push({
                                type: 'noproduct-supplier',
                                supplier: {
                                    supplierName: supplier.supplierName,
                                    supplierId: supplier.supplierId,
                                    supplierCode: supplier.supplierCode
                                },
                                subCat: {
                                    subCategoryName: subcategoryName,
                                    subCategoryid: subCategoryId
                                },
                                supplierLambdaData: supplier.lambdaData,
                                supplierNormalizedLambdaData: supplier.normalizedLambdaData,
                                supplierDataPanelData: supplier.dataPanelData,
                                supplierNow: 0,
                                supplierRec: parseFloat((parseFloat(supplier.lambdaData?.allocatedShareSupplier) || 0).toFixed(2)),
                                barcode: `noproduct-supplier-${supplier.supplierId}`,
                                name: supplier.supplierName
                            });
                        }
                    });
                }
                return dataToProcess;

            case "category":
                // Remove duplicates based on category name
                dataToProcess = Array.from(new Map(originalToSimulateProduct
                    .filter(prod => prod?.categoryName && prod.categoryName !== "")
                    .map(prod => [prod.categoryName, prod])
                ).values());

                // Add noproduct categories if available (only if not in filter mode)
                if (this.props.hierarchyData?.noproductCategories && !this.state.isInFilterMode) {
                    this.props.hierarchyData.noproductCategories.forEach(category => {
                        const existingCategoryById = dataToProcess.find(prod =>
                            prod?.categoryId === category.categoryId
                        );
                        const alreadyAddedNoproduct = dataToProcess.find(prod =>
                            prod?.type === 'noproduct-category' &&
                            prod?.categoryId === category.categoryId
                        );
                        if (!existingCategoryById && !alreadyAddedNoproduct) {
                            dataToProcess.push({
                                type: 'noproduct-category',
                                categoryId: category.categoryId,
                                categoryName: category.categoryName,
                                categoryLambdaData: category.lambdaData,
                                categoryNormalizedLambdaData: category.normalizedLambdaData,
                                categoryDataPanelData: category.dataPanelData,
                                categoryNow: 0,
                                categoryRec: parseFloat((parseFloat(category.lambdaData?.allocatedShareCategory) || 0).toFixed(2)),
                                barcode: `noproduct-cat-${category.categoryId}`,
                                name: category.categoryName
                            });
                        }
                    });
                }
                return dataToProcess;

            case "sub-category":
                // Remove duplicates based on subcategory name
                dataToProcess = Array.from(new Map(originalToSimulateProduct.map(prod => [prod?.subCat?.subCategoryName, prod])).values());

                // Add noproduct subcategories if available (only if not in filter mode)
                if (this.props.hierarchyData?.noproductSubcategories && !this.state.isInFilterMode) {
                    this.props.hierarchyData.noproductSubcategories.forEach(subcategory => {
                        const existingSubCatById = dataToProcess.find(prod =>
                            prod?.subCat?.subCategoryid === subcategory.subCategoryId
                        );
                        const alreadyAddedNoproduct = dataToProcess.find(prod =>
                            prod?.type === 'noproduct-subcategory' &&
                            prod?.subCat?.subCategoryid === subcategory.subCategoryId
                        );
                        if (!existingSubCatById && !alreadyAddedNoproduct) {
                            dataToProcess.push({
                                type: 'noproduct-subcategory',
                                subCat: {
                                    subCategoryName: subcategory.subcategoryName,
                                    subCategoryid: subcategory.subCategoryId
                                },
                                categoryId: subcategory.lambdaData?.categoryId,
                                categoryName: subcategory.lambdaData?.categoryName,
                                subCategoryLambdaData: subcategory.lambdaData,
                                subCategoryNormalizedLambdaData: subcategory.normalizedLambdaData,
                                subCategoryDataPanelData: subcategory.dataPanelData,
                                subCatNow: 0,
                                subCatRec: parseFloat((parseFloat(subcategory.lambdaData?.allocatedShareSubcategory) || 0).toFixed(2)),
                                barcode: `noproduct-subcat-${subcategory.subCategoryId}`,
                                name: subcategory.subcategoryName
                            });
                        }
                    });
                }
                return dataToProcess;

            default:
                return dataToProcess;
        }
    };

    if (!query) {
        const processedData = getProcessedDataForTab(activeTab);
        this.setState({ toSimulateProduct: processedData });
        return;
    }

    const lowerCaseQuery = query.toLowerCase();
    const dataToFilter = getProcessedDataForTab(activeTab);

    const filteredItems = dataToFilter.filter((item) => {
        switch (activeTab) {
            case "product":
                return ((item?.name || "").toLowerCase().includes(lowerCaseQuery)) ||
                       ((item?.barcode || "").toLowerCase().includes(lowerCaseQuery));
            case "brand":
                return ((item?.brand?.brandName || "").toLowerCase().includes(lowerCaseQuery));
            case "supplier":
                return ((item?.supplier?.supplierName || "").toLowerCase().includes(lowerCaseQuery));
            case "category":
                return ((item?.categoryName || "").toLowerCase().includes(lowerCaseQuery));
            case "sub-category":
                return ((item?.subCat?.subCategoryName || "").toLowerCase().includes(lowerCaseQuery));
            default:
                return false;
        }
    });

    this.setState({
        toSimulateProduct: filteredItems
    });
};

// Get Lambda data value for a specific filter column
    getLambdaDataValue = (filterShort, prod, cardType) => {
        const isToggleOn = this.props.isNormalizeToggleOn;
        
        // Create filter object with short property that the shared function expects
        const filter = { short: filterShort };
        
        // Call the shared function and get the result
        let value = getSharedLambdaDataValue(filter, {
            prod,
            prodBrand: prod, // In tab context, prod represents the hierarchy item
            prodSubCat: prod,
            prodCat: prod,
            prodSup: prod,
            cardType,
            isToggleOn,
            toSimulateProductonly: this.state.toSimulateProduct,
            isExcelExport: true
        });

        // formatting for Excel export: Add subcategory in brackets for brand and supplier names
        if (filterShort === 'BN' && cardType === 'brand' && value && value !== '-') {
            // For brand name in brand tab, add subcategory in brackets
            const subCategoryName = prod?.subCat?.subCategoryName;
            if (subCategoryName) {
                value = `${value} (${subCategoryName})`;
            }
        } else if (filterShort === 'SPN' && cardType === 'supplier' && value && value !== '-') {
            // For supplier name in supplier tab, add subcategory in brackets
            const subCategoryName = prod?.subCat?.subCategoryName;
            if (subCategoryName) {
                value = `${value} (${subCategoryName})`;
            }
        }

        return value;
    }

//DATA PANEL REPORT CR - 2025 May
    handleDownloadClick = () => {
        if (this.props.historyData?.past?.length > 0) {
            confirmAlert({
                title: this.props.t('There_are_unsaved_changes'),
                message: this.props.t("DO_YOU_WANT_TO_SAVE_AND_PRINT"),
                overlayClassName: (this.props.isRTL === "rtl" ? "alertrtl-content" : ""),
                buttons: [{
                    label: this.props.t('SavenPrint'),
                    onClick: () => {
                        // Set flag to trigger download after component re-renders
                        this.props.setShouldDownloadAfterRefresh(true);
                        this.props.handleSaveMP();
                    }
                }, {
                    label: this.props.t('btnnames.close'),
                }]
            });
        } else {
            this.generateDataPanelExcelExport();
        }
    }

    // Helper function to get translated tab name
    getTranslatedTabName = (tabName) => {
        const tabTranslationMap = {
            'product': 'DATA_PANEL.product',
            'brand': 'DATA_PANEL.brand',
            'supplier': 'DATA_PANEL.supplier',
            'category': 'DATA_PANEL.category',
            'sub-category': 'DATA_PANEL.subCat'
        };
        let translatedName = this.props.t(tabTranslationMap[tabName] || tabName);

        // For English, convert "Sub Category" to "Subcategory"
        if (this.props.i18n?.language === 'en' && tabName === 'sub-category') {
            translatedName = 'Subcategory';
        }

        return translatedName;
    }

    getLambdaValueForSort = (product, filterKey, cardType, isToggleOn = false) => {
        const fieldName = getFieldNameForCardType(filterKey, cardType);
        if (!fieldName) return 0;

        let value = null;

        // Check if it's a dataPanelData field
        if (DATA_PANEL_DATA_FIELDS.includes(filterKey)) {
            if (isToggleOn) {
                let normalizedData = null;
                if (cardType === 'product') {
                    normalizedData = product?.normalizedLambdaData;
                } else if (cardType === 'brand') {
                    normalizedData = product?.brandNormalizedLambdaData;
                } else if (cardType === 'supplier') {
                    normalizedData = product?.supplierNormalizedLambdaData;
                } else if (cardType === 'category') {
                    normalizedData = product?.categoryNormalizedLambdaData;
                } else if (cardType === 'sub-category') {
                    normalizedData = product?.subCategoryNormalizedLambdaData;
                }

                if (normalizedData && normalizedData[fieldName] !== undefined) {
                    value = normalizedData[fieldName];
                } else {
                    let dataPanelData = null;
                    if (cardType === 'product') {
                        dataPanelData = product?.dataPanelData;
                    } else if (cardType === 'brand') {
                        dataPanelData = product?.brandDataPanelData;
                    } else if (cardType === 'supplier') {
                        dataPanelData = product?.supplierDataPanelData;
                    } else if (cardType === 'category') {
                        dataPanelData = product?.categoryDataPanelData;
                    } else if (cardType === 'sub-category') {
                        dataPanelData = product?.subCategoryDataPanelData;
                    }

                    if (!dataPanelData || dataPanelData[fieldName] === undefined) return '';
                    value = dataPanelData[fieldName];
                }
            } else {
                let dataPanelData = null;
                if (cardType === 'product') {
                    dataPanelData = product?.dataPanelData;
                } else if (cardType === 'brand') {
                    dataPanelData = product?.brandDataPanelData;
                } else if (cardType === 'supplier') {
                    dataPanelData = product?.supplierDataPanelData;
                } else if (cardType === 'category') {
                    dataPanelData = product?.categoryDataPanelData;
                } else if (cardType === 'sub-category') {
                    dataPanelData = product?.subCategoryDataPanelData;
                }

                if (!dataPanelData || dataPanelData[fieldName] === undefined) return '';
                value = dataPanelData[fieldName];
            }
        } else {
            // Handle Lambda data fields
            let lambdaData = null;
            if (cardType === 'product') {
                lambdaData = product?.lambdaData;
            } else if (cardType === 'brand') {
                lambdaData = product?.brandLambdaData;
            } else if (cardType === 'supplier') {
                lambdaData = product?.supplierLambdaData;
            } else if (cardType === 'category') {
                lambdaData = product?.categoryLambdaData;
            } else if (cardType === 'sub-category') {
                lambdaData = product?.subCategoryLambdaData;
            }

            if (!lambdaData || lambdaData[fieldName] === undefined) return '';
            value = lambdaData[fieldName];
        }

        // For date fields, return timestamp for sorting
        if (fieldName === 'arigoCreationDate') {
            return value ? new Date(value).getTime() : 0;
        }

        return value ?? '';
    }

    // Sort products array by sortConfig (matching UI behavior)
    getSortedProductsForExport = (products, cardType) => {
        const currentTab = this.props.dataPanelTab || 'product';
        const sortConfig = this.props.tabSortConfig[currentTab] || { key: null, direction: 'desc' };
        const isToggleOn = this.props.isNormalizeToggleOn;

        if (!sortConfig.key) {
            // Default sort by 'now' value descending
            return [...products].sort((a, b) => {
                let aNow = 0, bNow = 0;
                if (cardType === 'product') {
                    aNow = a.now ?? 0;
                    bNow = b.now ?? 0;
                } else if (cardType === 'brand') {
                    aNow = a.brandNow ?? 0;
                    bNow = b.brandNow ?? 0;
                } else if (cardType === 'sub-category') {
                    aNow = a.subCatNow ?? 0;
                    bNow = b.subCatNow ?? 0;
                } else if (cardType === 'category') {
                    aNow = a.categoryNow ?? 0;
                    bNow = b.categoryNow ?? 0;
                } else if (cardType === 'supplier') {
                    aNow = a.supplierNow ?? 0;
                    bNow = b.supplierNow ?? 0;
                }
                return bNow - aNow; // Descending
            });
        }

        // Sort by Lambda data column
        return [...products].sort((a, b) => {
            const aValue = this.getLambdaValueForSort(a, sortConfig.key, cardType, isToggleOn);
            const bValue = this.getLambdaValueForSort(b, sortConfig.key, cardType, isToggleOn);

            const isNumericField = NUMERIC_FIELDS.includes(sortConfig.key);
            const isTextField = TEXT_FIELDS.includes(sortConfig.key);
            const isCodeField = CODE_FIELDS.includes(sortConfig.key);
            const isBooleanField = BOOLEAN_FIELDS.includes(sortConfig.key);
            const isDateField = DATE_FIELDS.includes(sortConfig.key);

            // Numeric fields: desc = highest first, asc = lowest first
            if (isNumericField) {
                const aNum = typeof aValue === 'number' ? aValue : 0;
                const bNum = typeof bValue === 'number' ? bValue : 0;

                if (sortConfig.direction === 'desc') {
                    return bNum - aNum; // Highest first
                } else {
                    return aNum - bNum; // Lowest first
                }
            }
            // Text, Code, Boolean, Date fields: desc = A-Z, asc = Z-A
            else if (isTextField || isCodeField || isBooleanField || isDateField) {
                const aStr = String(aValue ?? '').toLowerCase();
                const bStr = String(bValue ?? '').toLowerCase();

                if (sortConfig.direction === 'desc') {
                    return aStr.localeCompare(bStr); // A-Z
                } else {
                    return bStr.localeCompare(aStr); // Z-A
                }
            }
            // Fallback to string comparison
            else {
                const aStr = String(aValue ?? '').toLowerCase();
                const bStr = String(bValue ?? '').toLowerCase();

                if (sortConfig.direction === 'desc') {
                    return aStr.localeCompare(bStr); // A-Z
                } else {
                    return bStr.localeCompare(aStr); // Z-A
                }
            }
        });
    }
    getExcelNumberFormat = (filterShort) => {
        const fieldName = PREPLAN_FIELD_MAPPINGS[filterShort];

        const integerFields = ['totalFacing', 'shelfCapacity', 'storeCountWithSales', 'barcodeCount'];
        const percentageFields = ['weightedSharePlanogram', 'actualSharePlanogram', 'weightedShareCategory',
            'actualShareCategory', 'weightedShareSubCategory', 'actualShareSubCategory',
            'shareOfSaleUnit', 'shareOfSaleCurrency', 'shareOfSaleProfit', 'profitabilityPercent'];
        const currencyKFields = ['salesCurrency', 'profitCurrency'];
        const thousandSeparatorFields = ['dailySalesRateCurrency', 'dailySalesRateUnits', 'salesPerFacing',
            'unitsPerFacing', 'salesPerMeter', 'unitsPerMeter', 'salesUnits'];

        if (integerFields.includes(fieldName)) {
            return '#,##0';
        } else if (percentageFields.includes(fieldName)) {
            return '0.##';
        } else if (currencyKFields.includes(fieldName)) {
            return '#,##0.##';
        } else if (thousandSeparatorFields.includes(fieldName)) {
            return '#,##0.##';
        } else {
            return '0.##';
        }
    }

    getRawNumericValue = (filterShort, prod, cardType) => {
        const fieldName = getFieldNameForCardType(filterShort, cardType);
        if (!fieldName) return null;

        const isToggleOn = this.props.isNormalizeToggleOn;
        let value = null;

        if (DATA_PANEL_DATA_FIELDS.includes(filterShort)) {
            if (isToggleOn) {
                let normalizedData = null;
                if (cardType === 'product') {
                    normalizedData = prod?.normalizedLambdaData;
                } else if (cardType === 'brand') {
                    normalizedData = prod?.brandNormalizedLambdaData;
                } else if (cardType === 'supplier') {
                    normalizedData = prod?.supplierNormalizedLambdaData;
                } else if (cardType === 'category') {
                    normalizedData = prod?.categoryNormalizedLambdaData;
                } else if (cardType === 'sub-category') {
                    normalizedData = prod?.subCategoryNormalizedLambdaData;
                }

                if (normalizedData && normalizedData[fieldName] !== undefined) {
                    value = normalizedData[fieldName];
                } else {
                    let dataPanelData = null;
                    if (cardType === 'product') {
                        dataPanelData = prod?.dataPanelData;
                    } else if (cardType === 'brand') {
                        dataPanelData = prod?.brandDataPanelData;
                    } else if (cardType === 'supplier') {
                        dataPanelData = prod?.supplierDataPanelData;
                    } else if (cardType === 'category') {
                        dataPanelData = prod?.categoryDataPanelData;
                    } else if (cardType === 'sub-category') {
                        dataPanelData = prod?.subCategoryDataPanelData;
                    }

                    if (!dataPanelData || dataPanelData[fieldName] === undefined) return null;
                    value = dataPanelData[fieldName];
                }
            } else {
                let dataPanelData = null;
                if (cardType === 'product') {
                    dataPanelData = prod?.dataPanelData;
                } else if (cardType === 'brand') {
                    dataPanelData = prod?.brandDataPanelData;
                } else if (cardType === 'supplier') {
                    dataPanelData = prod?.supplierDataPanelData;
                } else if (cardType === 'category') {
                    dataPanelData = prod?.categoryDataPanelData;
                } else if (cardType === 'sub-category') {
                    dataPanelData = prod?.subCategoryDataPanelData;
                }

                if (!dataPanelData || dataPanelData[fieldName] === undefined) return null;
                value = dataPanelData[fieldName];
            }
        } else {
            if (isToggleOn && hasNormalizedData(filterShort, cardType)) {
                let normalizedData = null;
                if (cardType === 'product') {
                    normalizedData = prod?.normalizedLambdaData;
                } else if (cardType === 'brand') {
                    normalizedData = prod?.brandNormalizedLambdaData;
                } else if (cardType === 'supplier') {
                    normalizedData = prod?.supplierNormalizedLambdaData;
                } else if (cardType === 'category') {
                    normalizedData = prod?.categoryNormalizedLambdaData;
                } else if (cardType === 'sub-category') {
                    normalizedData = prod?.subCategoryNormalizedLambdaData;
                }

                if (!normalizedData || normalizedData[fieldName] === undefined) return null;
                value = normalizedData[fieldName];
            } else {
                let lambdaData = null;
                if (cardType === 'product') {
                    lambdaData = prod?.lambdaData;
                } else if (cardType === 'brand') {
                    lambdaData = prod?.brandLambdaData;
                } else if (cardType === 'supplier') {
                    lambdaData = prod?.supplierLambdaData;
                } else if (cardType === 'category') {
                    lambdaData = prod?.categoryLambdaData;
                } else if (cardType === 'sub-category') {
                    lambdaData = prod?.subCategoryLambdaData;
                }

                if (!lambdaData || lambdaData[fieldName] === undefined) return null;
                value = lambdaData[fieldName];
            }
        }

        return value;
    }

    generateDataPanelExcelExport = ()=>{
        // Remove duplicates based on the brand name when content is "brand"
        let uniqueBrands = this.state.toSimulateProduct;
        if (this.props.dataPanelTab === "brand" && this.state.toSimulateProduct) {
            uniqueBrands = Array.from(new Map(this.state.toSimulateProduct.map(prod => {
                const key = `${prod?.brand?.brandName}-${prod?.subCat?.subCategoryName}`;
                return [key, prod];
            })).values());

            // Add noproduct brand hierarchy items from endpoint (only if not in filter/search mode)
            if (this.props.hierarchyData?.noproductBrands && !this.state.isInSearchMode && !this.state.isInFilterMode) {
                this.props.hierarchyData.noproductBrands.forEach(brand => {
                    // Extract subcategory info - for noproduct brands, subcategoryName is at root level
                    const subcategoryName = brand.subcategoryName || brand.lambdaData?.subcategoryName;
                    const subCategoryId = brand.subCategoryId || brand.lambdaData?.subCategoryId;

                    const existingBrandById = uniqueBrands.find(prod =>
                        prod?.brand?.brandid === brand.brandId &&
                        prod?.subCat?.subCategoryName === subcategoryName
                    );

                    // Also check if this noproduct brand is already added
                    const alreadyAddedNoproduct = uniqueBrands.find(prod =>
                        prod?.type === 'noproduct-brand' &&
                        prod?.brand?.brandid === brand.brandId &&
                        prod?.subCat?.subCategoryName === subcategoryName
                    );

                    if (!existingBrandById && !alreadyAddedNoproduct) {
                        const brandIdKey = `${brand.brandId}-${subcategoryName}`;
                        // Create a product-like structure for the noproduct brand
                        uniqueBrands.push({
                            type: 'noproduct-brand',
                            brand: {
                                brandName: brand.brandName,
                                brandid: brand.brandId
                            },
                            subCat: {
                                subCategoryName: subcategoryName,
                                subCategoryid: subCategoryId
                            },
                            brandLambdaData: brand.lambdaData,
                            brandNormalizedLambdaData: brand.normalizedLambdaData,
                            brandDataPanelData: brand.dataPanelData,
                            brandNow: 0,
                            brandRec: parseFloat((parseFloat(brand.lambdaData?.allocatedShareBrand) || 0).toFixed(2)),
                            barcode: `noproduct-brand-${brandIdKey}`,
                            name: brand.brandName
                        });
                    }
                });
            }
        }



        // Remove duplicates based on the subCat name when content is "brand"
        let uniqueSubCat = this.state.toSimulateProduct;
        if (this.props.dataPanelTab === "sub-category" && this.state.toSimulateProduct) {
            uniqueSubCat = Array.from(new Map(this.state.toSimulateProduct.map(prod => [prod?.subCat?.subCategoryName, prod])).values());

            // Add noproduct subcategory hierarchy items from endpoint (only if not in filter/search mode)
            if (this.props.hierarchyData?.noproductSubcategories && !this.state.isInSearchMode && !this.state.isInFilterMode) {
                this.props.hierarchyData.noproductSubcategories.forEach(subcategory => {
                    // Check for existing subcategory by ID (more reliable than name)
                    const existingSubCatById = uniqueSubCat.find(prod =>
                        prod?.subCat?.subCategoryid === subcategory.subCategoryId
                    );

                    // Also check if this noproduct subcategory is already added
                    const alreadyAddedNoproduct = uniqueSubCat.find(prod =>
                        prod?.type === 'noproduct-subcategory' &&
                        prod?.subCat?.subCategoryid === subcategory.subCategoryId
                    );

                    if (!existingSubCatById && !alreadyAddedNoproduct) {
                        // Create a product-like structure for the noproduct subcategory
                        uniqueSubCat.push({
                            type: 'noproduct-subcategory',
                            subCat: {
                                subCategoryName: subcategory.subcategoryName,
                                subCategoryid: subcategory.subCategoryId
                            },
                            categoryId: subcategory.lambdaData?.categoryId,
                            categoryName: subcategory.lambdaData?.categoryName,
                            subCategoryLambdaData: subcategory.lambdaData,
                            subCategoryNormalizedLambdaData: subcategory.normalizedLambdaData,
                            subCategoryDataPanelData: subcategory.dataPanelData,
                            subCatNow: 0,
                            subCatRec: parseFloat((parseFloat(subcategory.lambdaData?.allocatedShareSubcategory) || 0).toFixed(2)),
                            barcode: `noproduct-subcat-${subcategory.subCategoryId}`,
                            name: subcategory.subcategoryName
                        });
                    }
                });
            }
        
        }

        let uniqueCategory = this.state.toSimulateProduct;
        if (this.props.dataPanelTab === "category" && this.state.toSimulateProduct) {
            uniqueCategory = Array.from(
                new Map(
                    this.state.toSimulateProduct
                        .filter(prod => prod?.categoryName && prod.categoryName !== "")
                        .map(prod => [prod.categoryName, prod])
                ).values()
            );

            // Add noproduct category hierarchy items from endpoint (only if not in filter/search mode)
            if (this.props.hierarchyData?.noproductCategories && !this.state.isInSearchMode && !this.state.isInFilterMode) {
                this.props.hierarchyData.noproductCategories.forEach(category => {
                    // Check for existing category by ID (more reliable than name)
                    const existingCategoryById = uniqueCategory.find(prod =>
                        prod?.categoryId === category.categoryId
                    );

                    // Also check if this noproduct category is already added
                    const alreadyAddedNoproduct = uniqueCategory.find(prod =>
                        prod?.type === 'noproduct-category' &&
                        prod?.categoryId === category.categoryId
                    );

                    if (!existingCategoryById && !alreadyAddedNoproduct) {
                        // Create a product-like structure for the noproduct category
                        uniqueCategory.push({
                            type: 'noproduct-category',
                            categoryId: category.categoryId,
                            categoryName: category.categoryName,
                            categoryLambdaData: category.lambdaData,
                            categoryNormalizedLambdaData: category.normalizedLambdaData,
                            categoryDataPanelData: category.dataPanelData,
                            categoryNow: 0,
                            categoryRec: parseFloat((parseFloat(category.lambdaData?.allocatedShareCategory) || 0).toFixed(2)),
                            barcode: `noproduct-cat-${category.categoryId}`,
                            name: category.categoryName
                        });
                    }
                });
            }
        }

        // Remove duplicates based on the supplier name + subcategory combination when content is "supplier"
        let uniqueSupplier = this.state.toSimulateProduct;
        if (this.props.dataPanelTab === "supplier" && this.state.toSimulateProduct) {
            uniqueSupplier = Array.from(new Map(this.state.toSimulateProduct.map(prod => {
                const key = `${prod?.supplier?.supplierName}-${prod?.subCat?.subCategoryName}`;
                return [key, prod];
            })).values());

            // Add noproduct supplier hierarchy items from endpoint (only if not in filter/search mode)
            if (this.props.hierarchyData?.noproductSuppliers && !this.state.isInSearchMode && !this.state.isInFilterMode) {
                this.props.hierarchyData.noproductSuppliers.forEach(supplier => {
                    // Extract subcategory info - for noproduct suppliers, subcategoryName is at root level
                    const subcategoryName = supplier.subcategoryName || supplier.lambdaData?.subcategoryName;
                    const subCategoryId = supplier.subCategoryId || supplier.lambdaData?.subCategoryId;

                    // Check for existing supplier by ID (more reliable than name)
                    const existingSupplierById = uniqueSupplier.find(prod =>
                        prod?.supplier?.supplierId === supplier.supplierId
                    );

                    // Also check if this noproduct supplier is already added
                    const alreadyAddedNoproduct = uniqueSupplier.find(prod =>
                        prod?.type === 'noproduct-supplier' &&
                        prod?.supplier?.supplierId === supplier.supplierId
                    );

                    if (!existingSupplierById && !alreadyAddedNoproduct) {
                        // Create a product-like structure for the noproduct supplier
                        uniqueSupplier.push({
                            type: 'noproduct-supplier',
                            supplier: {
                                supplierName: supplier.supplierName,
                                supplierId: supplier.supplierId,
                                supplierCode: supplier.supplierCode
                            },
                            subCat: {
                                subCategoryName: subcategoryName,
                                subCategoryid: subCategoryId
                            },
                            supplierLambdaData: supplier.lambdaData,
                            supplierNormalizedLambdaData: supplier.normalizedLambdaData,
                            supplierDataPanelData: supplier.dataPanelData,
                            supplierNow: 0,
                            supplierRec: parseFloat((parseFloat(supplier.lambdaData?.allocatedShareSupplier) || 0).toFixed(2)),
                            barcode: `noproduct-supplier-${supplier.supplierId}`,
                            name: supplier.supplierName
                        });
                    }
                });
            }
        }

        this.setState({loadinggif: true}, () => {
            
            const fileExtension = '.xlsx'
            let csvData = []

            let baseStyles = { 
                font: { bold: true }, 
                fill: { fgColor: { rgb: "E9E9E9" } }, 
                alignment: { wrapText: false } 
            };

            let isrtlview = (this.props.isRTL === "rtl");

            // Apply right alignment for RTL, keep base styles for LTR
            const styles = isrtlview 
                ? { ...baseStyles, alignment: { ...baseStyles.alignment, horizontal: "right" } } 
                : baseStyles; 
            
            let headerstyles = { font: { bold: true, sz: "16" }, fill: { fgColor: { rgb: "f8f8F8" } }, alignment: { wrapText: false, horizontal: "center" } };
            let smallheaderstyles = { font: { bold: true, sz: "14" }, fill: { fgColor: { rgb: "f8f8F8" } }, alignment: { wrapText: false, horizontal: "center" } };

            // let chaindetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.chain:null);
            // let departmentname = (this.props.defSaveObj && this.props.defSaveObj.department?(((this.props.simType === "AUI")?cluster?.department?.importName:cluster?.department?.importName)+" "+this.props.t("department")):"-");
            // let userdetails = (this.props.signedobj && this.props.signedobj.signinDetails?this.props.signedobj.signinDetails.userDto:null);
            // let fieldCount = (this.props.simulateCount > 0?this.props.simulateCount:0);
            // let mpDetails = ((this.props.defSaveObj && this.props.defSaveObj.masterPlanogram)?this.props.defSaveObj.masterPlanogram:undefined);

            // let MPVersion = (mpDetails?mpDetails.version:"");
            // let MPVName = (this.props.originatedMpId > 0?this.props.originatedMpName:mpDetails?mpDetails.name:"");
            // let isOriginatedMPAvailable = (this.props.originatedMpId > 0);

            const cluster = (this.props.clusterData || []).find((item) => {
                return (item?.id && item.id === this.props.selectedClusterId) ||
                       (item?.clusterId && item.clusterId === this.props.selectedClusterId);
            });

            

            let departmentname = cluster?.department?.importName || cluster?.department?.departmentName || "";
            let userdetails = this.props?.signState?.signinDetails?.userDto || {};

            let MPVersion = this.props?.EditionName;
            let MPVName = cluster?.name || cluster?.clusterName || this.props?.defSaveObj?.masterPlanogram?.name || this.props?.originatedMpName || "";
            let isOriginatedMPAvailable = "sdsd";
            const headerCenter = this.props.isRTL === 'rtl'
                ? ([MPVName, MPVersion, departmentname].filter(Boolean).join(' | '))
                : ([departmentname, MPVersion, MPVName].filter(Boolean).join(' | '));

            csvData.push([{v: "", s: headerstyles},{v: "", s: headerstyles},{v: (this.props.t('PLANOGRAM_SIMULATION_REPORT')), s: headerstyles},{v: "", s: headerstyles},{v: "", s: headerstyles},{v: "", s: headerstyles}]);
            csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: headerCenter, s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
            csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: (this.props.t("REPORT_DATE") +": "+moment().format("DD/MM/YYYY HH:mm:ss")), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
            csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: (this.props.t("DATE_RANGE") +": "+moment(this.props.saleStartDate).format("DD/MM/YYYY") +" - "+ moment(this.props.saleEndDate).format("DD/MM/YYYY")), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
            csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: (this.props.t("LEVEL") +": "+this.getTranslatedTabName(this.props.dataPanelTab)), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
            csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: (this.props.t("NORMALIZED_LABEL") +": "+(this.props.isNormalizeToggleOn ? "Yes" : "No")), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
            csvData.push([{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: (this.props.t("GENERATED_BY") +": "+userdetails?.fName +" "+ userdetails?.lName), s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles},{v: "", s: smallheaderstyles}]);
            
            

            csvData.push([{v: ""}]);

            const safeVal = (val) => (val ?? "");

            // sort all arrays by 'now' value descending to match UI order
            const sortedProducts = this.getSortedProductsForExport(this.state.toSimulateProduct || [], 'product');
            const sortedBrands = this.getSortedProductsForExport(uniqueBrands || [], 'brand');
            const sortedSupplier = this.getSortedProductsForExport(uniqueSupplier || [], 'supplier');
            const sortedCategory = this.getSortedProductsForExport(uniqueCategory || [], 'category');
            const sortedSubCat = this.getSortedProductsForExport(uniqueSubCat || [], 'sub-category');

            if(this.props.dataPanelTab === 'product'){
                
                const headersRow = getTabSpecificOptions(this.props.dataPanelTab).map((item) => {
                return { v: this.props.t(item.label), s: styles }
                })
                csvData.push(headersRow)

                sortedProducts?.map((product) => {
                    let row = [];
                    
                    TAB_SPECIFIC_FIELDS.product.map((item)=>{
                        if (NUMERIC_FIELDS.includes(item)) {
                            const rawValue = this.getRawNumericValue(item, product, this.props.dataPanelTab);
                            if (rawValue !== null && rawValue !== undefined && rawValue !== '') {
                                // Round to 2 decimals to avoid floating point artifacts
                                const roundedValue = Math.round(Number(rawValue) * 100) / 100;
                                // Check if it's a whole number to use appropriate format
                                const isWholeNumber = roundedValue % 1 === 0;
                                const baseFormat = this.getExcelNumberFormat(item);
                                // Remove decimal part from format if whole number
                                const format = isWholeNumber ? baseFormat.replace('.##', '') : baseFormat;
                                row.push({
                                    v: roundedValue,
                                    t: 'n',
                                    z: format
                                });
                            } else {
                                row.push({v: ''});
                            }
                        } else {
                            const lamda = this.getLambdaDataValue(item, product, this.props.dataPanelTab);
                            row.push({v:lamda});
                        }
                    })
                    
                    csvData.push(row);
                })

            }
            else if (this.props.dataPanelTab === 'brand'){
                const headersRow = getTabSpecificOptions(this.props.dataPanelTab).map((item) => {
                return { v: this.props.t(item.label), s: styles }
                })
                csvData.push(headersRow)
                sortedBrands?.map((product) => {
                    let row = [];

                    TAB_SPECIFIC_FIELDS.brand.map((item)=>{
                        if (NUMERIC_FIELDS.includes(item)) {
                            const rawValue = this.getRawNumericValue(item, product, this.props.dataPanelTab);
                            if (rawValue !== null && rawValue !== undefined && rawValue !== '') {
                                // Round to 2 decimals to avoid floating point artifacts
                                const roundedValue = Math.round(Number(rawValue) * 100) / 100;
                                // Check if it's a whole number to use appropriate format
                                const isWholeNumber = roundedValue % 1 === 0;
                                const baseFormat = this.getExcelNumberFormat(item);
                                // Remove decimal part from format if whole number
                                const format = isWholeNumber ? baseFormat.replace('.##', '') : baseFormat;
                                row.push({
                                    v: roundedValue,
                                    t: 'n',
                                    z: format
                                });
                            } else {
                                row.push({v: ''});
                            }
                        } else {
                            const lamda = this.getLambdaDataValue(item, product, this.props.dataPanelTab);
                            row.push({v:lamda});
                        }
                    })
                    
                    csvData.push(row);
                    
                })
            }else if (this.props.dataPanelTab === 'supplier'){
         const headersRow = getTabSpecificOptions(this.props.dataPanelTab).map((item) => {
                return { v: this.props.t(item.label), s: styles }
                })
                csvData.push(headersRow)
                sortedSupplier?.map((product) => {
                    let row = [];
                    
                   TAB_SPECIFIC_FIELDS.supplier.map((item)=>{
                        if (NUMERIC_FIELDS.includes(item)) {
                            const rawValue = this.getRawNumericValue(item, product, this.props.dataPanelTab);
                            if (rawValue !== null && rawValue !== undefined && rawValue !== '') {
                                // Round to 2 decimals to avoid floating point artifacts
                                const roundedValue = Math.round(Number(rawValue) * 100) / 100;
                                // Check if it's a whole number to use appropriate format
                                const isWholeNumber = roundedValue % 1 === 0;
                                const baseFormat = this.getExcelNumberFormat(item);
                                // Remove decimal part from format if whole number
                                const format = isWholeNumber ? baseFormat.replace('.##', '') : baseFormat;
                                row.push({
                                    v: roundedValue,
                                    t: 'n',
                                    z: format
                                });
                            } else {
                                row.push({v: ''});
                            }
                        } else {
                            const lamda = this.getLambdaDataValue(item, product, this.props.dataPanelTab);
                            row.push({v:lamda});
                        }
                    })
                    
                    csvData.push(row);
                })
            }else if (this.props.dataPanelTab === 'category'){

                 const headersRow = getTabSpecificOptions(this.props.dataPanelTab).map((item) => {
                return { v: this.props.t(item.label), s: styles }
                })
                csvData.push(headersRow)
                sortedCategory?.map((product) => {
                    let row = [];
                   
                    TAB_SPECIFIC_FIELDS.category.map((item)=>{
                        if (NUMERIC_FIELDS.includes(item)) {
                            const rawValue = this.getRawNumericValue(item, product, this.props.dataPanelTab);
                            if (rawValue !== null && rawValue !== undefined && rawValue !== '') {
                                // Round to 2 decimals to avoid floating point artifacts
                                const roundedValue = Math.round(Number(rawValue) * 100) / 100;
                                // Check if it's a whole number to use appropriate format
                                const isWholeNumber = roundedValue % 1 === 0;
                                const baseFormat = this.getExcelNumberFormat(item);
                                // Remove decimal part from format if whole number
                                const format = isWholeNumber ? baseFormat.replace('.##', '') : baseFormat;
                                row.push({
                                    v: roundedValue,
                                    t: 'n',
                                    z: format
                                });
                            } else {
                                row.push({v: ''});
                            }
                        } else {
                            const lamda = this.getLambdaDataValue(item, product, this.props.dataPanelTab);
                            row.push({v:lamda});
                        }
                    })
                    
                    csvData.push(row);
                })

            }else{
                 const headersRow = getTabSpecificOptions(this.props.dataPanelTab).map((item) => {
                return { v: this.props.t(item.label), s: styles }
                })
                csvData.push(headersRow)
                sortedSubCat.map((product) => {
                    let row = [];
                    
                     TAB_SPECIFIC_FIELDS["sub-category"].map((item)=>{
                        if (NUMERIC_FIELDS.includes(item)) {
                            const rawValue = this.getRawNumericValue(item, product, this.props.dataPanelTab);
                            if (rawValue !== null && rawValue !== undefined && rawValue !== '') {
                                // Round to 2 decimals to avoid floating point artifacts
                                const roundedValue = Math.round(Number(rawValue) * 100) / 100;
                                // Check if it's a whole number to use appropriate format
                                const isWholeNumber = roundedValue % 1 === 0;
                                const baseFormat = this.getExcelNumberFormat(item);
                                // Remove decimal part from format if whole number
                                const format = isWholeNumber ? baseFormat.replace('.##', '') : baseFormat;
                                row.push({
                                    v: roundedValue,
                                    t: 'n',
                                    z: format
                                });
                            } else {
                                row.push({v: ''});
                            }
                        } else {
                            const lamda = this.getLambdaDataValue(item, product, this.props.dataPanelTab);
                            row.push({v:lamda});
                        }
                    })

                    
                    csvData.push(row);
                })
            }

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(csvData);

            // Set column widths to prevent ######## display
            const columnCount = csvData[8]?.length || 30; // Use header row length or default to 30
            ws['!cols'] = Array(columnCount).fill({ wch: 15 }); // Set all columns to width 15

            //need merge headers with my header text 
            // 2. Prepare the merges array
            ws["!merges"] = ws["!merges"] || [];
            ws["!merges"].push(
                { s: { r: 0, c: 2 }, e: { r: 0, c: 26 } }, // Merging first row
                { s: { r: 1, c: 2 }, e: { r: 1, c: 26 } }, // Merging second row
                { s: { r: 2, c: 2 }, e: { r: 2, c: 26 } }, // Merging third row
                { s: { r: 3, c: 2 }, e: { r: 3, c: 26 } }, // Merging fourth row
                { s: { r: 4, c: 2 }, e: { r: 4, c: 26 } }, // Merging fifth row
                { s: { r: 5, c: 2 }, e: { r: 5, c: 26 } }, // Merging sixth row
                { s: { r: 6, c: 2 }, e: { r: 6, c: 26 } } // Merging seventh row
            )

            XLSX.utils.book_append_sheet(wb, ws, "readme");

            const reportLabel = this.props.t('PLANOGRAM_SIMULATION_REPORT');
            const translatedTabName = this.getTranslatedTabName(this.props.dataPanelTab);
            const fileName = `${reportLabel}_${translatedTabName}${fileExtension}`;

            XLSX.writeFile(wb, fileName, { bookType: 'xlsx', type: 'binary' });
            this.setState({loadinggif:false})
        })
        
    }

    render() {
        const { itemSort, toSimulateProduct } = this.state
        const isToggleOn = this.props.isNormalizeToggleOn;
        // console.log(toSimulateProduct,"____toSimulateProduct")
        // console.log(this.props.formValue, "formValue1");
        
        return (
            <Row>
                <Col xs={12} style={{ padding: "0 10px 10px 10px" }}>
                    <Tab.Container activeKey={this.props.dataPanelTab} onSelect={this.props.handleDataPanelTab}>
                        <Row>
                            <Col className='editprod-view'>
                                <Nav variant="pills" className="flex-row aui-navs" style={{flexWrap: 'nowrap'}}>
                                    <Nav.Item>
                                        <Nav.Link eventKey="product">{this.props.t("DATA_PANEL.product")}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="brand">{this.props.t("DATA_PANEL.brand")}</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="supplier">{this.props.t("DATA_PANEL.supplier")}</Nav.Link>
                                    </Nav.Item>
                                      <Nav.Item>
                                        <Nav.Link eventKey="category">{this.props.t("DATA_PANEL.category")}</Nav.Link>
                                    </Nav.Item>
                                     <Nav.Item>
                                        <Nav.Link eventKey="sub-category">{this.props.t("DATA_PANEL.subCat")}</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <div className="table-filter-container">
                                <div
                                    className="table-filter-container-left"
                                    style={
                                        i18n.dir() === 'rtl'
                                            ? { marginLeft: 10 }
                                            : { marginRight: 10 }
                                    }
                                >
                                    <SearchBar
                                        activeTab={this.props.dataPanelTab}
                                        onSearch={this.handleSearch}
                                        toSimulateProduct={toSimulateProduct}
                                        filterSimulatedDataFunction={this.filterSimulatedData}
                                        onSearchModeChange={this.handleSearchModeChange}
                                    />
                                </div>
                                <div className="table-filter-container-right">
                                    <>
                                        <style>
                                            {`
                                                .form-check-input {
                                                    border-color: #323233 !important;
                                                }
                                                .form-check-input:focus {
                                                    border-color: #323233 !important;
                                                    box-shadow: none !important;
                                                }
                                                .form-check-input:checked {
                                                    background-color: #E5E7EB !important;
                                                    border-color: #323233 !important;
                                                }
                                                .form-check-input:checked::before {
                                                    background-color: #323233 !important;
                                                }
                                                .form-switch .form-check-input:checked {
                                                    background-position: right center;
                                                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23000'/%3e%3c/svg%3e");
                                                }
                                            `}
                                        </style>
                                        <ToggleButton
                                            isToggleOn={isToggleOn}
                                            onToggle={this.handleToggle}
                                            isRTL = {this.props.isRTL}
                                            t={this.props.t}
                                        />
                                    </>
                                    <span ref={this.settingsIconRef}>
                                        <FeatherIcon 
                                            icon="settings" 
                                            size={20} 
                                            style={{
                                                cursor: "pointer", 
                                                marginBottom: 2, 
                                                marginRight: 5, 
                                                color: this.props.dmode ? 'white' : 'black' 
                                            }} 
                                            onClick={this.handleOpenFilterModal} 
                                        />
                                        </span>
                                </div>
                            </div>
                            <Col xs={12} className="Hproductsdiv">
                                <Tab.Content>
                                    <Tab.Pane eventKey="product">
                                        <DataPanelTabContent
                                            itemSort={itemSort}
                                            toSimulateProductonly={toSimulateProduct}
                                            content={"product"}
                                            catDivHeight={this.props.catDivHeight}
                                            simType={this.props.simType}
                                            isRTL={this.props.isRTL}
                                            formValue={this.props.formValue}
                                            drawRectCanvas={this.props.drawRectCanvas}
                                            dragStart={this.props.dragStart}
                                            dragProdView={this.props.dragProdView}
                                            prodDragEnd={this.props.prodDragEnd}
                                            handleopenDetailmodal={this.props.handleopenDetailmodal}
                                            handlePreviewModal={this.props.handlePreviewModal}
                                            copyToClipboard={this.props.copyToClipboard}
                                            hangableFilter={this.props.onHangableFilterChange}
                                            filterSelections={this.getCurrentFilterSelections()}
                                            dmode= {this.props.dmode}
                                            isToggleOn={isToggleOn}
                                            isLoadingLambdaDataPanel={this.props.isLoadingLambdaDataPanel}
                                            isInSearchMode={this.state.isInSearchMode}
                                            isInFilterMode={this.state.isInFilterMode}
                                            actualFieldStructures={this.props.actualFieldStructures}
                                            sortConfig={this.props.tabSortConfig['product']}
                                            handleColumnSort={this.handleColumnSort}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="brand">
                                        <DataPanelTabContent
                                            itemSort={itemSort}
                                            content={"brand"}
                                            toSimulateProductonly={toSimulateProduct}
                                            formValue={this.props.formValue}
                                            catDivHeight={this.props.catDivHeight}
                                            simType={this.props.simType}
                                            isRTL={this.props.isRTL}
                                            loadingNow={this.props.loadingNow}
                                            filterSelections={this.getCurrentFilterSelections()}
                                            dmode= {this.props.dmode}
                                            isToggleOn={isToggleOn}
                                            isLoadingLambdaDataPanel={this.props.isLoadingLambdaDataPanel}
                                            isInSearchMode={this.state.isInSearchMode}
                                            isInFilterMode={this.state.isInFilterMode}
                                            hierarchyData={this.props.hierarchyData}
                                            actualFieldStructures={this.props.actualFieldStructures}
                                            sortConfig={this.props.tabSortConfig['brand']}
                                            handleColumnSort={this.handleColumnSort}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="supplier">
                                        <DataPanelTabContent
                                            itemSort={itemSort}
                                            content={"supplier"}
                                            toSimulateProductonly={toSimulateProduct}
                                            formValue={this.props.formValue}
                                            catDivHeight={this.props.catDivHeight}
                                            simType={this.props.simType}
                                            isRTL={this.props.isRTL}
                                            loadingNow={this.props.loadingNow}
                                            filterSelections={this.getCurrentFilterSelections()}
                                            dmode= {this.props.dmode}
                                            isToggleOn={isToggleOn}
                                            isLoadingLambdaDataPanel={this.props.isLoadingLambdaDataPanel}
                                            isInSearchMode={this.state.isInSearchMode}
                                            isInFilterMode={this.state.isInFilterMode}
                                            hierarchyData={this.props.hierarchyData}
                                            actualFieldStructures={this.props.actualFieldStructures}
                                            sortConfig={this.props.tabSortConfig['supplier']}
                                            handleColumnSort={this.handleColumnSort}
                                        />
                                    </Tab.Pane>
                                     <Tab.Pane eventKey="category">
                                        <DataPanelTabContent
                                            itemSort={itemSort}
                                            content={"category"}
                                            toSimulateProductonly={toSimulateProduct}
                                            formValue= {this.props.formValue}
                                            catDivHeight={this.props.catDivHeight}
                                            simType={this.props.simType}
                                            isRTL={this.props.isRTL}
                                            loadingNow={this.props.loadingNow}
                                            filterSelections={this.getCurrentFilterSelections()}
                                            dmode= {this.props.dmode}
                                            isToggleOn={isToggleOn}
                                            isLoadingLambdaDataPanel={this.props.isLoadingLambdaDataPanel}
                                            isInSearchMode={this.state.isInSearchMode}
                                            isInFilterMode={this.state.isInFilterMode}
                                            hierarchyData={this.props.hierarchyData}
                                            actualFieldStructures={this.props.actualFieldStructures}
                                            sortConfig={this.props.tabSortConfig['category']}
                                            handleColumnSort={this.handleColumnSort}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="sub-category">
                                        <DataPanelTabContent
                                            itemSort={itemSort}
                                            content={"sub-category"}
                                            toSimulateProductonly={toSimulateProduct}
                                            formValue={this.props.formValue}
                                            catDivHeight={this.props.catDivHeight}
                                            simType={this.props.simType}
                                            isRTL={this.props.isRTL}
                                            loadingNow={this.props.loadingNow}
                                            filterSelections={this.getCurrentFilterSelections()}
                                            dmode= {this.props.dmode}
                                            isToggleOn={isToggleOn}
                                            isLoadingLambdaDataPanel={this.props.isLoadingLambdaDataPanel}
                                            isInSearchMode={this.state.isInSearchMode}
                                            isInFilterMode={this.state.isInFilterMode}
                                            hierarchyData={this.props.hierarchyData}
                                            actualFieldStructures={this.props.actualFieldStructures}
                                            sortConfig={this.props.tabSortConfig['sub-category']}
                                            handleColumnSort={this.handleColumnSort}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                                {/* EXPORT FUNCTION GOES HERE */}
                                  {/* <Button onClick={()=>this.generateDataPanelExcelExport()} variant='success' 
                                  className={"btn-save-cat "+(this.props.isRTL === "rtl"?"float-left":"float-right")}>{this.props.t("btnnames.export")}</Button> */}
                                 <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                     <div style={{display:'flex',alignItems:'center',gap:'5px'}}>
                                        <span
                                            className="download-ico"
                                            onClick={()=>this.props.processLambdaDataPanelResult(true)}
                                            style={{position: 'relative'}}
                                            title={this.props.hasChangesSinceLastRefresh ? this.props.t('RECENT_CHANGES_REFRESH') : ""}
                                        >
                                            <RefreshCcw
                                                size={24}
                                                color={this.props.dmode ? "#2CC990" : "#000"}
                                            />
                                            {this.props.hasChangesSinceLastRefresh && (
                                                <span style={{
                                                    position: 'absolute',
                                                    top: '-2px',
                                                    right: '-2px',
                                                    backgroundColor: '#FF6B35',
                                                    borderRadius: '50%',
                                                    width: '14px',
                                                    height: '14px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '10px',
                                                    fontWeight: 'bold',
                                                    color: 'white',
                                                    border: '1px solid white'
                                                }}>
                                                    !
                                                </span>
                                            )}
                                        </span>
                                     </div>
                                    <span
                                        className="download-ico"
                                        onClick={()=>!(this.props.isLoadingLambdaDataPanel || this.props.loadingNow) && this.handleDownloadClick()}
                                        style={{
                                            opacity: (this.props.isLoadingLambdaDataPanel || this.props.loadingNow) ? 0.5 : 1,
                                            cursor: (this.props.isLoadingLambdaDataPanel || this.props.loadingNow) ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        <FeatherIcon
                                            icon="download"
                                            size={24}
                                            color={this.props.dmode ? "#2CC990" : "#000"}
                                        />
                                    </span>
                                 </div>
                                <DataPanelFilterSelectionModal
                                  show={this.state.showFilterModal}
                                  onHide={this.handleCloseFilterModal}
                                  onConfirm={this.handleFilterConfirm}
                                  selectedOptions={this.getCurrentFilterSelections()}
                                  targetRef={this.settingsIconRef}
                                  options={getTabSpecificOptions(this.props.dataPanelTab)}
                                  simType={this.props.simType}
                                  activeTab={this.props.dataPanelTab}
                                  isNormalizeToggleOn={this.props.isNormalizeToggleOn}
                                />
                            </Col>
                        </Row>
                    </Tab.Container>
                </Col>
            </Row>
        );
    }

}

const mapStateToProps = (state) => ({
  signState: state.signState,
  shouldDownloadAfterRefresh: state.simulateAll?.shouldDownloadAfterRefresh,
  isNormalizeToggleOn: state.simulateAll?.isNormalizeToggleOn ?? false,
  tabFilterSelections: state.simulateAll?.tabFilterSelections || {
    'product': [],
    'brand': [],
    'supplier': [],
    'category': [],
    'sub-category': []
  },
  tabSortConfig: state.simulateAll?.tabSortConfig || {
    'product': { key: null, direction: 'desc' },
    'brand': { key: null, direction: 'desc' },
    'supplier': { key: null, direction: 'desc' },
    'category': { key: null, direction: 'desc' },
    'sub-category': { key: null, direction: 'desc' }
  }
})

const mapDispatchToProps = (dispatch) => ({
  setShouldDownloadAfterRefresh: (value) => dispatch(setShouldDownloadAfterRefresh(value)),
  setTabFilterSelections: (tab, selections) => dispatch(setTabFilterSelections(tab, selections)),
  setTabSortConfig: (tab, config) => dispatch(setTabSortConfig(tab, config)),
  setNormalizeToggleOn: (value) => dispatch(setNormalizeToggleOn(value)),
})

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(DataPanelTab)))